(function () {
  'use strict';

  const CUSTOM_VALUES = ['price-real-ascending', 'price-real-descending'];

  let isSorting = false;

  function getGrid() {
    const anyItem = document.querySelector('.bls__product-item');
    return anyItem ? anyItem.parentElement : null;
  }

  function sortGrid(value) {
    const grid = getGrid();
    if (!grid) {
      console.log('[sort-debug] no product item found, cannot find grid');
      return;
    }

    const items = Array.from(grid.querySelectorAll(':scope > .bls__product-item'));
    if (!items.length) {
      console.log('[sort-debug] no direct-child product items found');
      return;
    }

    items.sort((a, b) => {
      const priceA = parseFloat(a.dataset.realPrice) || 0;
      const priceB = parseFloat(b.dataset.realPrice) || 0;
      return value === 'price-real-ascending' ? priceA - priceB : priceB - priceA;
    });

    isSorting = true;
    items.forEach((item) => grid.appendChild(item));
    window.__customSortActive = value;

    setTimeout(() => {
      isSorting = false;
    }, 50);
  }

  function updateSelectedUI(clickedLi, value) {
    document.querySelectorAll('#SortBy li[value]').forEach((li) => {
      li.classList.remove('selected');
      li.removeAttribute('selected');
    });
    document.querySelectorAll(`#SortBy li[value="${value}"]`).forEach((li) => {
      li.classList.add('selected');
    });

    const desktopLabel = document.querySelector('.toolbar-sorter .select-selected span');
    if (desktopLabel) {
      desktopLabel.textContent = clickedLi.textContent.trim();
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      const li = e.target.closest('#SortBy li[value]');
      if (!li) return;

      const value = li.getAttribute('value');
      if (CUSTOM_VALUES.includes(value)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        updateSelectedUI(li, value);
        sortGrid(value);
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    const grid = getGrid();
    if (!grid) return;
    const observer = new MutationObserver(function () {
      if (isSorting) return;
      if (window.__customSortActive) {
        sortGrid(window.__customSortActive);
      }
    });
    observer.observe(grid, { childList: true, subtree: false }); // ab sirf grid ke direct children observe honge, poora page nahi
  });
})();